import windowDays from '@/function/calendar/calendar.window.days';
import recurringCalendarBillings from '@/function/recurring/recurring.calendar.billings';
import type { TypeWindowKey } from '@/function/calendar/calendar.window';
import { dropById, upsertById } from '@/store/api/base/api.cache';
import { recurringCalendarApi } from '@/store/api/recurring/recurring.calendar.api';
import { store, type TypeAppDispatch } from '@/store/store';
import type { TypeRecurring } from '@/types/recurring/types.recurring';

const cachedWindows = (): TypeWindowKey[] =>
    recurringCalendarApi.util.selectCachedArgsForQuery(store.getState(), 'listRecurringCalendarWindow') as TypeWindowKey[];

export const writeRecurringCalendar = (dispatch: TypeAppDispatch, recurring: TypeRecurring): void => {
    for (const key of cachedWindows()) {
        const { from, to } = windowDays(key);
        const belongs = recurringCalendarBillings([recurring], from, to).length > 0;
        dispatch(recurringCalendarApi.util.updateQueryData('listRecurringCalendarWindow', key, (draft) => {
            if (belongs) upsertById(draft.items, recurring); else dropById(draft.items, recurring.id);
        }));
    }
};

export const dropRecurringCalendar = (dispatch: TypeAppDispatch, id: string): void => {
    for (const key of cachedWindows()) {
        dispatch(recurringCalendarApi.util.updateQueryData('listRecurringCalendarWindow', key, (draft) => { dropById(draft.items, id); }));
    }
};
